var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkbox",class:{ checked: _vm.value },on:{"click":_vm.onClickCheckbox}},[(_vm.value)?_c('i',{staticClass:"material-icons"},[_vm._v("check")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }